import { bundleStatus } from "../Selectors/bundles";
import { getBundlesUrl, getBundleParams } from "../../Helpers/bundle";
export var getBundlesData = function getBundlesData(params, reqProps) {
  return function (dispatch, getState, _ref) {
    var get = _ref.get;
    var BXP_REQUIRED_HEADER = {
      'x-panamera-client-id': "web-".concat(params.platform)
    };
    var state = getState();
    var url = getBundlesUrl(state, reqProps.url, params);
    var bundleState = bundleStatus(state, url);
    var isFetching = bundleState.isFetching;
    var hasData = bundleState.hasData;
    var hasFailed = bundleState.isError;
    if (!isFetching && !hasData && !hasFailed) {
      return dispatch(get(url, reqProps.type, null, BXP_REQUIRED_HEADER)).then(function (res) {
        if (res && res.data) {
          return Promise.resolve(res.data);
        }
        return Promise.reject(res);
      });
    }
    return Promise.resolve();
  };
};
export var getBundles = function getBundles(reqProps) {
  return function (dispatch, getState) {
    var state = getState();
    var params = getBundleParams(reqProps, state);
    return dispatch(getBundlesData(params, reqProps));
  };
};